export default "__VITE_ASSET__CIn2CHh5__"